/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterRSmall = createReactComponent("outline", "letter-r-small", "IconLetterRSmall", [["path", { "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4", "key": "svg-0" }]]);

export { IconLetterRSmall as default };
//# sourceMappingURL=IconLetterRSmall.mjs.map
